import BarcodeListComponent from "@/components/sharedComponents/print/barcodeList/barcodeList.component";
import InventoryLabelListComponent from "@/components/sharedComponents/print/inventoryLabelList/InventoryLabelList.component";
import { EventBus } from "@/event-bus";
import { BatchSample, InventoryBatch, PrintBarcode } from "@/interfaces/batch";
import { PrintLabelTableMetadata } from "@/metadata/printNewBatch";
import { i18n } from "@/plugins/i18n";
import { labResultsService } from "@/services/labResults.service";
import { batchFormatedforLabResults } from "@/utils/batch-actions.utils";
import {
  TableComponent,
  TableHeader,
  TableItem,
  TablePagination
} from "helix-vue-components";
import chunk from "lodash/chunk";
import cloneDeep from "lodash/cloneDeep";
import orderBy from "lodash/orderBy";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import Template from "./InboundTransferPrintLabels.template.vue";
@Component({
  mixins: [Template],
  components: {
    TableComponent
  }
})
export default class InboundTransferPrintLabels extends Vue {
  @Getter("bioTrackTraceEnabled", { namespace: "AuthModule" })
  public bioTrackTraceEnabled!: boolean;
  public pagination: TablePagination = {
    totalItems: 0,
    itemsPerPage: 5,
    lastPage: 20,
    itemsPerPageOptions: [5, 10, 15, 20],
    currentPage: 1,
    from: 1,
    to: 5
  };
  public paginationDefault: TablePagination = cloneDeep(this.pagination);
  public headers: TableHeader[] = PrintLabelTableMetadata;
  public batchSamples: BatchSample | null = null;
  public loadingSamples = false;
  public item = {};
  public printData: InventoryBatch[] = [];
  public printTableData: PrintBarcode[] = [];
  public defaultSelectedItems: number[] = [];
  public selected: number = 0;
  public noOfStrain = 0;
  public finish() {
    this.$router.push({
      name: "batch-transfer",
      params: { type: "inbound-transfer" }
    });
  }
  public get rowActions() {
    return [
      {
        icon: "fal fa-barcode-alt",
        tooltip: String(i18n.t("print_barcode")),
        action: this.printBarcode
      },
      {
        icon: "fal fa-print",
        tooltip: String(i18n.t("print_label.print_inventory_lable")),
        action: this.printLabel
      }
    ];
  }
  public setTableData(item: PrintBarcode[]) {
    const isSelected = true;
    const newBatchPrint = true;
    this.printTableData = item.map((batch: PrintBarcode) => {
      if (batch.product!.strain) {
        this.noOfStrain++;
      }
      return {
        ...batch,
        product_name:
          batch!.product!.name +
          `(${batch.quantity_value! + batch.quantity_unit})`,
        batch_uid:
          this.bioTrackTraceEnabled && batch.product!.marijuana === 1
            ? batch.batch!.biotrack_traceability_id
            : batch!.batch_uid,
        product_category: batch.product ? batch.product.category!.name : "",
        batch_type: batch.product!.batch_type!.name,
        strain: batch.product!.strain ? batch.product!.strain.name : "-",
        quantity: batch.quantity_value!,
        id: batch.id,
        barcodes: "-",
        inventory_labels: "-",
        is_selected: isSelected,
        name: batch!.product!.name,
        sku: batch.sku,
        weighable: batch!.product!.requires_weighing,
        product: batch!.product,
        product_variant: batch!.product,
        new_batch_print: newBatchPrint
      };
    });
    if (this.noOfStrain === 0) {
      this.printTableData.forEach(data => {
        if (data.strain && data.strain !== "-") {
          this.noOfStrain++;
        }
      });
    }
    if (this.noOfStrain === 0) {
      this.headers = this.headers.filter(
        (header: any) => header.value !== "strain"
      );
    }
    if (this.printTableData.length < 5) {
      this.pagination.to = this.printTableData.length;
    } else {
      this.pagination.to = 5;
    }
  }
  public selectedBatch(data: PrintBarcode) {
    return this.printTableData.findIndex(item => item.id === data.id);
  }
  public onSelectItem(data: TableItem) {
    if (data.eventItem) {
      const index = this.selectedBatch(data.eventItem.item);
      if (index !== -1) {
        this.printTableData[index].is_selected = data.eventItem.status;
      }
    } else {
      data.currentSelection.map((items: PrintBarcode) => {
        const index = this.selectedBatch(items);
        if (index !== -1) {
          this.printTableData[index].is_selected = data.checkAll;
        }
      });
    }
    this.selected = data.currentSelection.length;
    this.printData = data.currentSelection;
  }
  public get tableData() {
    this.pagination.totalItems = this.printTableData.length;
    return (
      (this.pagination &&
        chunk(this.printTableData, this.pagination.itemsPerPage)[
          this.pagination.currentPage - 1
        ]) ||
      []
    );
  }
  public onSort(header: TableHeader) {
    this.printTableData = orderBy(
      this.printTableData,
      header.value,
      header.descending ? "desc" : "asc"
    );
  }
  public onChangePage(pagination: TablePagination) {
    this.pagination.currentPage = pagination.currentPage;
    const from =
      (pagination.currentPage - 1) * this.pagination.itemsPerPage + 1;
    const to =
      (pagination.currentPage - 1) * this.pagination.itemsPerPage +
      this.tableData.length;
    this.pagination.totalItems = this.printTableData.length;
    this.pagination.from = (from > 0 && from) || 0;
    this.pagination.to = (to > 0 && to) || 0;
  }
  /**
   * Prints barcode
   */
  public printBarcode(item: PrintBarcode) {
    EventBus.$emit("print", {
      component: BarcodeListComponent,
      props: {
        batches: [item]
      }
    });
  }
  public async getSamples() {
    if (!this.batchSamples && this.item && !this.loadingSamples) {
      this.loadingSamples = true;
      this.batchSamples = await labResultsService.getBatchSamples(
        this.printTableData[0].batch_uid!
      );
      this.loadingSamples = false;
    }
  }
  public async printLabel(item: PrintBarcode) {
    await this.getSamples();
    const hasLab = !!this.batchSamples!.laboratory;
    EventBus.$emit("print", {
      component: InventoryLabelListComponent,
      props: {
        batches: [
          {
            ...item,
            laboratory: hasLab
              ? batchFormatedforLabResults(this.batchSamples!)
              : null,
            sample: hasLab ? this.batchSamples : null,
            product: item,
            fatherItem: {
              laboratory_name: hasLab
                ? this.batchSamples!.laboratory!.name
                : "N/A",
              laboratory_license: hasLab
                ? this.batchSamples!.laboratory!.license
                : "N/A",
              laboratory_testing_date: hasLab
                ? this.batchSamples!.testing_date
                : "N/A"
            }
          }
        ],
        labelType: "INVENTORY"
      }
    });
  }
  public mounted() {
    EventBus.$on("inboundTransferPrintLabels", (code: any) => {
      this.setTableData(code);
    });
  }
}
